<template>
  <div class="wrapper">
    <div class="tilte-text"> 公众号授权 </div>
    <div class="auth-wrap">
      <div class="auth-box">
        <el-row>
          <el-col :span="24">
            <div class="detail-box" v-if="bindPackage.length > 0">
              <div class="detail-div">
                <div class="operate-div" v-for="(item, index) of bindPackage" :key="index">
                  <div>
                    <img v-if="item.headImg" :src="item.headImg" alt="">
                    <img v-else src="../../../../assets/img/kfc/weishouquan.png" alt="">
                  </div>
                  <div class="wechat-info">
                    <div class="wechat-title" v-if="item.platformName == '' && item.platformUuid == ''">待授权公众号</div>
                    <div class="wechat-title" v-else>{{ item.platformName }}</div>
                  </div>
                  <div class="flex-box">
                    <div v-if="item.platformName == '' && item.platformUuid == ''">
                      <span class="wechat-btn">
                        <!--                      <a :href="authLink" target="_blank">去授权公众号</a>-->
                        <iframe frameborder="0" class="auth-btn" :src="authLink"></iframe>
                      </span>
                    </div>
                    <div v-else><span class="wechat-btn" @click="lookLink(item)">查看专属推广链接</span></div>
                    <div class="margin-left-10"><span class="wechat-btn" @click="toHome(item)">进入系统</span></div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="auth-detail">
      <el-row>
        <el-col :span="12" class="left-box">
          <div class="auth-title">授权说明</div>
          <div class="auth-tip">
            <div class="part-box">
              <div class="part-circle"></div>
              <div class="part-content"><span>授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</span></div>
            </div>
            <div class="part-box">
              <div class="part-circle"></div>
              <div class="part-content"><span>如果你是公众号的管理员，点击下方按钮，扫码授权即可。</span></div>
            </div>
            <div class="part-box">
              <div class="part-circle"></div>
              <div class="part-content">
                <span>如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</span>
              </div>
            </div>
            <div class="btn-box">
              <iframe frameborder="0" class="auth-btn" :src="addPublicauthLink"></iframe>
              <!--              <span class="auth-btn" @click="addWechat">添加新公众号</span>-->
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="right-box">
          <div class="notice-box">
            <div class="auth-title">注意事项</div>
            <div class="auth-tip">
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>授权成功后，请先同步消息模版</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>不要手动去删除微信公众号生成的消息模板</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>有任何出券码的问题，及时联系客服处理</span></div>
              </div>
            </div>
            <div class="qrcode-box">
              <div class="qrcode-div margin-right-10">
                <img class="qrcode-img" src="../../../../assets/img/kfc/service1.jpg" alt="">
                <div class="nickname">守兔票务-雪糕</div>
              </div>
              <div class="qrcode-div margin-left-10">
                <img class="qrcode-img" src="../../../../assets/img/kfc/service2.jpg" alt="">
                <div class="nickname">守兔票务-婷欧尼</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <promotion-link ref="link"></promotion-link>
  </div>
</template>

<script>
import PromotionLink from '@/components/kfc/PromotionLink.vue'
import { getUserUUID, getNickname, getPlatformUuidKfc, setPlatformUuidKfc, setPlatformNameKfc, setIsAuthKfc, setHeadImgKfc } from '@/utils/auth'
import kfc from '@/javaApi/kfc/kfc'
const kfcModel = new kfc()
import official from '@/javaApi/official'
const officialModel = new official()

export default {
  name: 'MyWechat',
  components: {
    PromotionLink
  },
  data: function () {
    return {
      listLoading: false,
      platformUuid: getPlatformUuidKfc(),
      userUUID: getUserUUID(),
      bindPackage: [],
      authLink: process.env.VUE_APP_KFC_AUTH_URL + 'third/go/auth-pub?openUserUuid=' + getUserUUID() + '&openUserNickname=' + getNickname() + '&buttonText=去授权公众号',
      addPublicauthLink: process.env.VUE_APP_KFC_AUTH_URL + 'third/go/auth-pub?openUserUuid=' + getUserUUID() + '&openUserNickname=' + getNickname() + '&buttonText=添加新公众号'
    }
  },
  created() {
    this.loadPubilc();
  },
  methods: {
    loadPubilc: function () {
      this.listLoading = true
      officialModel.getAuthPublicList({ openUserUuid: getUserUUID() }).then((response) => {
        this.listLoading = false
        var res = response.data
        console.log(response)
        if (res.success) {
          if (res.data && res.data.binds && res.data.binds.length > 0) {
            this.bindPackage = res.data.binds
            // 取第一条公众号数据，做为默认公众号
            var defaultKfc = res.data.binds[0];
            setPlatformUuidKfc(defaultKfc.platformUuid) // 公众号UUID
            setPlatformNameKfc(defaultKfc.platformName) // 公众号名称
            setHeadImgKfc(defaultKfc.headImg) // 公众号logo

            // 公众号是否已授权
            if (defaultKfc.platformUuid !== '' && defaultKfc.platformName !== '') {
              setIsAuthKfc(true)
            } else {
              setIsAuthKfc(false)
            }
            this.$store.dispatch('kfc/changePlatformNameKfc', defaultKfc.platformName)
            this.$store.dispatch('kfc/changeHeadImgKfc', defaultKfc.headImg)
          } else {
            setPlatformUuidKfc(0);
            setPlatformNameKfc('')
            setHeadImgKfc('')
            setIsAuthKfc(false)
            this.isAuth = false
            this.$store.dispatch('kfc/changePlatformNameKfc', '')
            this.$store.dispatch('kfc/changeHeadImgKfc', '')
          }
        } else {
          setPlatformUuidKfc(0);
          setPlatformNameKfc('')
          setHeadImgKfc('')
          setIsAuthKfc(false)
          this.isAuth = false
          this.$store.dispatch('kfc/changePlatformNameKfc', '')
          this.$store.dispatch('kfc/changeHeadImgKfc', '')
          this.$Message.error(res.message)
          return
        }
      }).catch(error => {
        console.log(error)
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    lookLink: function (row) {
      this.$refs.link.init(row)
      console.log('查看专属推广链接')
    },
    //跳转到主页
    toHome(item) {
      setPlatformUuidKfc(item.platformUuid);
      setPlatformNameKfc(item.platformName)
      setHeadImgKfc(item.headImg)
      if (item.platformUuid !== '' && item.platformName !== '') {
        setIsAuthKfc(true)
      } else {
        setIsAuthKfc(false)
      }

      this.$store.dispatch('kfc/changePlatformNameKfc', item.platformName)
      this.$store.dispatch('kfc/changeHeadImgKfc', item.headImg)
      this.$store.dispatch('nav/changeKfcAccountActiveIndex', 0)
      this.$router.push({ path: '/pc/kfc/statistics' })
    },
    // 添加公众号
    addWechat() {
      const searchForm = {
        openUserUuid: getUserUUID() ? getUserUUID() : '',
        openUserNickname: getNickname() ? getNickname() : ''
      }
      kfcModel.getAuth(searchForm).then(response => {
        let res = response.data
        if (res.success) {
          window.open(res.data, '_blank')
        } else {
          let message = res.message ? res.message : '系统异常请稍后再试'
          that.$message.error(message)
        }
      }).catch(error => {
        if (error != 'token invalid') {
          that.$message.error('系统异常请稍后再试')
        }
      })
    },
    toAuthorization() {
      setPlatformUuidKfc(0);
      setPlatformNameKfc('')
      setHeadImgKfc('')
      setIsAuthKfc(false)
      this.$store.dispatch('kfc/changePlatformNameKfc', '')
      this.$store.dispatch('kfc/changeHeadImgKfc', '')
    }
  }
}
</script>

<style scoped>
.margin-left-10 {
  margin-left: 10px;
}

.margin-right-10 {
  margin-right: 10px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.auth-wrap .auth-box {
  padding: 30px 30px 30px 0;
}

.auth-wrap .detail-box {
  border: 1px solid #EEEEEE;
  border-radius: 4px;
}

.auth-wrap .detail-box .detail-div {
  padding: 10px 20px;
}

.auth-wrap .detail-box .detail-div .operate-div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  color: #D63036;
  padding: 10px 0;
}

.auth-wrap .detail-box .detail-div .operate-div img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.auth-wrap .detail-box .detail-div .operate-div .wechat-info {
  margin: 0 30px 0 15px;
  font-family: Alibaba-PuHuiTi-R;
  width: 130px;
}

.auth-wrap .detail-box .detail-div .operate-div .wechat-info .wechat-title {
  font-size: 16px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}

.auth-wrap .detail-box .detail-div .operate-div .wechat-info .package {
  font-size: 13px;
  color: #3D9EFC;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}

.flex-box {
  display: flex;
}

.auth-wrap .detail-box .detail-div .operate-div .wechat-btn {
  border: 1px solid #1287EA;
  padding: 6px 16px;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  color: #1287EA;
}

.auth-wrap .detail-box .detail-div .operate-div .wechat-btn a {
  color: #1287EA;
}

.auth-detail .auth-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}

.auth-detail .auth-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #666666;
  margin-top: 12px;
}

.auth-detail .part-box {
  display: flex;
  flex-direction: row;
  padding: 8px 0;
}

.auth-detail .right-box .part-box {
  padding: 5px 0;
}

.auth-detail .part-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #D63036;
  margin: 5px 8px 5px 0;
}

.auth-detail .right-box .part-circle {
  background: #999999;
}

.auth-detail .part-content {
  width: 90%;
}

.auth-detail .left-box .btn-box {
  padding: 20px 10px;
}

.auth-detail .left-box .btn-box .auth-btn {
  font-family: Alibaba-PuHuiTi-R;
  background: #D63036;
  border-radius: 2px;
  color: #FFFFFF;
  margin: 0 auto;
  cursor: pointer;
  width: 143px;
  height: 40px;
  overflow: hidden;
}

.auth-detail .left-box .btn-box .auth-btn a {
  color: #FFFFFF;
}

.auth-detail .left-box {
  padding-right: 20px;
}

.auth-detail .right-box {
  padding-left: 20px;
}

.auth-detail .right-box .notice-box {
  min-width: 380px;
}

.auth-detail .right-box .notice-box .qrcode-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
}

.auth-detail .right-box .notice-box .qrcode-box .qrcode-div {
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  width: 180px;
  padding: 20px;
}

.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .qrcode-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
}

.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .nickname {
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/mywechat/Index.vue